// extracted by mini-css-extract-plugin
export default {"link":"CabecalhoLink_link__RXN79"};